export enum EStorage {
    MENU = 'cnseg_menu',
    FAVORITES = 'favorites',
    IMAGES = 'images'
}

export enum ELocalStorage{
    STORAGE = 'cnseg_storage',
}